
<div class="title" [class.active]="active" tabindex="0" (click)="makeActive()">
    {{title}}
</div>